<div class="hiperio-config-direct-details-view-container" *ngIf="hiperioConfigDirectObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).user.write" (click)="modifyRegistration()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="100"  fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Nazwa TU" [value]="hiperioConfigDirectObject.insuranceCompany.name"></app-detail>
              </div>

            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane dostępowe</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="OFWCA" [value]="hiperioConfigDirectObject.registration?.ofwca?.fullName"></app-detail>
              </div>

            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Rejestracja" [value]="hiperioConfigDirectObject?.registration?.insuranceCompany.name
                                          + ' ' + hiperioConfigDirectObject?.registration?.ofwca?.fullName"
                            [link]="hiperioConfigDirectObject?.registration ? ['/rejestracje/szczegoly', hiperioConfigDirectObject?.registration.uuid] : undefined">
                </app-detail>
              </div>

            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Status rejestracji " [value]="hiperioConfigDirectObject.registration?.status.name"></app-detail>
              </div>

            </div>
            <div fxLayout="row">
              <h4>Loginy</h4>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div  fxFlex="100" *ngFor="let name of hiperioConfigDirectObject.registrationIdName; let i = index">
                <app-detail [header]="name"     [value]="hiperioConfigDirectObject.registrationId[i]"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
